import React, { Component } from "react";
import Category from "./Category";
import { connect } from "react-redux";
import ActionButton from "../../ActionButton";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import { animateScroll as scroll, scroller } from "react-scroll";
class index extends Component {
  state = {
    drawerState: false,
    SelectedCategoryState: null,
  };
  toggleDrawer = (open, id) => {
    window.scrollBy(0, 5);
    window.scrollBy(0, -5);
    this.setState({ drawerState: open, SelectedCategoryState: id });
  };

  render() {
    const language = this.props.language;
    const categories = [];
    const themeColor = this.props.themeColor;
    const { selectedCategory } = this.props;
    let border =
      language === "english"
        ? { borderLeft: `4px solid ${themeColor}` }
        : { borderRight: `4px solid ${themeColor}` };
    let categories_Navigate = [];

    this.props.store.categories
      .filter((cat) => cat.products.length > 0)
      .forEach((category) => {
        categories.push(
          <Category
            key={"Grid_Category " + category.name + category.id}
            enName={category.name}
            arName={category.ar_name}
            category={category}
            history={this.props.history}
            onClick={(id) => this.toggleDrawer(true, id)}
          />
        );
        categories_Navigate.push(
          <div key={"Navigate_Category " + category.name + category.id}>
            <div
              onClick={(e) => {
                scroller.scrollTo("navigate" + category.id, {
                  duration: 0,
                  delay: 0,
                  offset: -110,
                  smooth: "easeInOutQuart",
                });
                this.toggleDrawer(false);
              }}
              style={
                category.id === this.state.SelectedCategoryState ? border : {}
              }
              className={`d-flex flex-row justify-content-between py-3 ${
                language === "arabic" ? "flex-row-reverse" : ""
              }  `}
            >
              <p class="my-auto mx-3 ">{`${
                language === "english" ? category.name : category.ar_name
              }`}</p>
              <p
                class=" my-auto"
                style={{
                  marginRight: language === "english" ? "1rem" : 0,
                  marginLeft: language === "arabic" ? "1.8rem" : 0,
                }}
              >
                {category.products.length}
              </p>
            </div>
            <hr className="half-line" />
          </div>
        );
      });

    return (
      <>
        <Drawer
          className="h-100"
          anchor="top"
          PaperProps={{
            className: this.props.language === "arabic" ? "ml-auto" : "",
          }}
          open={this.state.drawerState}
          onClose={() => this.toggleDrawer(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              overflowX: "hidden",
            }}
          >
            <div
              class={`  d-flex flex-row justify-content-between ${
                language === "arabic" ? "flex-row-reverse" : ""
              }  `}
              onClick={() => this.toggleDrawer(false)}
            >
              <p class=" font-weight-bold my-auto mx-3 ">{`${
                language === "english" ? "Menu List" : "القائمة"
              }`}</p>
              <div class="mx-2">
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => this.toggleDrawer(false)}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div>

            <Divider />
            {categories_Navigate}
          </div>
        </Drawer>
        <div className="mt-4" dir={language == "english" ? "ltr" : "rtl"}>
          {categories}
        </div>
        <div className="free-space-115"></div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    language: state.store.language,
    cart: state.cart,
    themeColor: state.store.store.settings.dark,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
  };
};

export default connect(mapStateToProps)(index);
